import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { DataUtil } from 'node_modules/@syncfusion/ej2-data';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { AppRoute } from 'src/app/shared/models/appRoute.model';

@Component({
  selector: 'app-app-routes',
  templateUrl: './app-routes.component.html',
  styleUrls: ['./app-routes.component.scss']
})
export class AppRoutesComponent implements OnInit {

   // setup as observable?
   @Input() item_id?: any; // impliments on changes.
   @Input() item_data?: any; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;

  @Input() promotion_id: number;
  @Input() current_route: any;



  search_model: AppRoute;
  model: AppRoute;
  addTypeClick: boolean;

           // toggle elements
        //  isShow = true;
        isShow_chart1 = false;
        isShow_chart2 = false;

        isShow_chart1_meta = false;
        isShow_chart2_meta = false; // user investigation as default
        isShow_chart3_meta = false; // user investigation as default
        // log view variables.
        isShow_created_by = false;
        isShow_data = false;
        isShow_data_tools = false;

        isShow_route_diagram = false;
        isShow_route_tree = false;
        isShow_route_grid = false;
        isShow_route_tree_map = false;
        isShow_route_tree_list = false;
        isShow_route_diagram_hierarchial = false;
        isShow_route_diagram_hierarchial_complex = false;
        isShow_route_diagram_local_data = false;
        isShow_route_diagram_on_init = false;
        isShow_route_diagram_users = false;
        isShow_route_diagram_over_view = false;
        isShow_route_diagram_radial_tree = false;
        isShow_route_diagram_app_network = false;
        isShow_route_diagram_kan_ban = false;
        isShow_route_diagram_kan_pan_data = true;
        isShow_route_diagram_proposal = false;

  app_routes_metrix_search_full: Object;
  app_routes_metrix_search_full_results: any;
  new_data: any;
  app_route: any;
  system_log_type_data_sectors: any;
  app_routes: any;
  dateFormat: string;
  app_route_types: any;
  app_route_insert_types: any;
  modalRef: any;
  projects: any;
  projects_data: any;

  constructor(
    public gfunc: GlobalFunctionsService,
    private _demoService: DemoService,
    private modalService: BsModalService,
  ) {



    this.dateFormat = 'dd/MM/yyyy hh:mm a';
   }

  ngOnInit(): void {

    this.search_model = new AppRoute();
    this.search_model = {
      // "routerLink": this.current_route,
      // "routerLinkGeneral": this.current_route // added to show other artivles that are general
      // Filter the information that a general route is one with no router link as the primary.... or spil in UI??? TO....
    }// set to empty to get all first.

    // if(this.current_route != ''){}
    this.getAppRoutesSearchFull(this.search_model);
    this.getSystemLogTypeDataSectors();
    this.getAppRouteTypes();
  this.getAppRouteInsertTypes();    
  this.getAppRoutes()
  this.getProjects()
  }

  ngOnChanges(changes): void  {
 
    this.model = new AppRoute()
    this.search_model = {}// set to empty to get all first.

    // this.getVariableCodeBlocksSearchFull(this.search_model);
    this.getAppRoutesSearchFull(this.search_model);
    this.getSystemLogTypeDataSectors();
    this.getAppRouteTypes();
    this.getAppRouteInsertTypes();    
    this.getAppRoutes()
  this.getProjects()
    

  }




  getAppRoutesSearchFull(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_full_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data = this.app_routes_metrix_search_full_results.slice(0, 500);
        this.app_route = this.new_data; // sets the data
  
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }


showQuoteRoutesOnly(){
  this.search_model = {
    app_route_type_id: 10,
  }// set to empty to get all first.
  this.getAppRoutesSearchFull(this.search_model);
}



showBaseAndQuoteRoutes(){
  this.search_model = {
    app_route_type_id: 10,
    app_route_type_id2: 6,
  }// set to empty to get all first.
  this.getAppRoutesSearchFull(this.search_model);
}






showTipsRoutesOnly(){
  this.search_model = {
    app_route_insert_type_id: 5,
  }// set to empty to get all first.
  this.getAppRoutesSearchFull(this.search_model);
}



  clearSearchResults(search_model){
    this.new_data = [];
    this.search_model = {}// set to empty to get all first.
    // this.getVariableCodeBlocksSearchFull(this.search_model);
    this.getAppRoutesSearchFull(this.search_model);
    // this.grid.refresh()
    
    }
    
    
    
    getSystemLogTypeDataSectors() {
      this._demoService.getSystemLogTypeDataSectors().subscribe(
         data => { this.system_log_type_data_sectors = data;
        
        },
         err => console.error(err),
         () => console.log('System Log Type')
       );
     }
    
    
    
     getAppRoutes() {
      this._demoService.getAppRoutes().subscribe(
         data => { this.app_routes = data;
        
        },
         err => console.error(err),
         () => console.log('System Log Type')
       );
     }






     getAppRouteTypes() {
      this._demoService.getAppRouteTypes().subscribe(
          data => { this.app_route_types = data; },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }
  
  
      getAppRouteInsertTypes() {
        this._demoService.getAppRouteInsertTypes().subscribe(
            data => { this.app_route_insert_types = data; },
            err => console.error(err),
            // () => console.log('done loading Trace Types')
          );
        }
    


      // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
      // small upgrade to disable background click on open modal background
      const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
      this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};  





getProjects() {
  this._demoService.getProjects().subscribe(
    data => {
      this.projects = data;
      let res = data[0]
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.projects_data = DataUtil.parse.parseJson(data);

// :: TO A loop of details below.




    },
    error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
    }
  );
}



}
